import UserService from '@/api/services/UserService';

export const namespaced = true;

export const state = {
  user: {},
  city: {},
  loading: false,
};

export const mutations = {
  LOADING(state, loading) {
    state.loading = loading;
  },
  SET_USER(state, user) {
    state.user = user;
  },
  CITYLOADING(state, loading) {
    state.cityLoading = loading;
  },
  SET_CITY(state, city) {
    state.city = city;
  },
};

export const actions = {
  fetchUser({ commit, dispatch }) {
    commit('LOADING', true);
    UserService.getUser()
      .then(response => {
        commit('SET_USER', response);
        commit('LOADING', false);
      })
      .catch(error => {
        // if (window.BASE_URL) {
        //   window.location.href = `${window.BASE_URL}/login`;
        // }
        commit('LOADING', false);
        const notification = {
          type: 'warning',
          message: 'There was an problem fetching the User:' + error.message,
        };

        dispatch('notification/add', notification, { root: true });
      });
  },
  fetchCity({ commit, dispatch }, { cityId }) {
    commit('CITYLOADING', true);
    UserService.fetchCity(cityId)
      .then(response => {
        commit('SET_CITY', response);
        commit('CITYLOADING', false);
      })
      .catch(error => {
        commit('CITYLOADING', false);
        error.location = 'fetchCity';
        console.log(error);

        const notification = {
          type: 'warning',
          message: 'Fail to retrieve city info.',
        };

        dispatch('notification/add', notification, { root: true });
      });
  },
};

export const getters = {};
